export default "__VITE_ASSET__8c92d3cf__"